module.exports = __webpack_public_path__ + "static/media/arc.ba45beff.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageCommercialPassword/arc.png
// module id = 605
// module chunks = 0